<template>
  <div class="ag-grid-date">
    <el-date-picker
      ref="agDate"
      v-model="value"
      :size="size"
      :format="format"
      :default-time="defaultTime"
      :value-format="valueFormat"
      :name="name"
      :type="type"
      :unlink-panels="unlinkPanels"
      :placeholder="isPlaceholder"
      :readonly="readonly"
      :disabled="disabled"
      :editable="editable"
      :clearable="clearable"
      :align="align"
      :default-value="defaultValue"
      :popper-class="popperClass"
      :prefix-icon="prefixIcon"
      :clear-icon="clearIcon"
      :validate-event="validateEvent"
      :picker-options="pickerOptions"
      @keydown.native="keydownAction"
      @change="changeEve"
      @focus="focusAction"
      @blur="blurAction"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { formatDate } from 'element-ui/src/utils/date-util'

export default {
  name: 'AgGridDate',
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    unlinkPanels: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'mini'
    },
    prefixIcon: {
      type: String,
      default: 'el-icon-date'
    },
    clearIcon: {
      type: String,
      default: 'el-icon-circle-close'
    },
    placeholder: {
      type: String,
      default: ''
    },
    popperClass: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: Date,
      default: ''
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    name: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: 'left'
    },
    type: {
      type: String,
      default: 'date'
    },
    // 当前时间日期选择器特有的选项参考下表
    pickerOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 组件唯一标识
    mark: {
      type: String,
      default: ''
    },
    // 当前行数据（ag-grid中使用必须有）
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    defaultCurrentDate: {
      type: Boolean,
      default: true
    },
    datetime: {
      type: String,
      default: 'start'
    },
    defaultTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: ''
    }
  },
  computed: {
    isPlaceholder() {
      return this.placeholder || this.$t('components.pleaseSelect')
    }
  },
  mounted() {
    // 返回当前组件指向
    this.mark && this.$emit('getComponent', this)
    this.$nextTick(() => {
      this.autoFocus && this.focus()
      // console.log('表格行数据--', this.params)
      if (this.params.value) {
        this.value = this.params.value // （ag-grid中使用必须有）
      } else if (this.defaultCurrentDate) {
        this.value = formatDate(new Date(), this.valueFormat)
        this.$emit('getVal', this.value)
      }
    })
  },
  // 销毁前触发失焦事件--解决ag-grid编辑状态回车计算问题
  beforeDestroy() {
    let tempValue = this.value
    if (typeof (tempValue) === 'string') {
      tempValue = new Date(tempValue)
    }
    const pseudoEvent = {
      mark: 'pseudoEvent',
      value: tempValue,
      target: {
        value: tempValue
      }
    }
    this.blurAction(pseudoEvent)
  },
  methods: {
    // 键盘事件
    keydownAction(e) {
      console.log('keydownAction', e)
      this.$emit('keydown', e)
    },
    // 选择器聚焦方法
    focus() {
      // console.log('this.$refs.agDate--', this.$refs.agDate)
      // this.$refs.agDate.$el.children[0].focus()
      const ref = this.$refs.agDate
      ref.focus()
      ref.handleFocus()
    },
    setValue(value) {
      this.value = value
      this.$emit('change', value)
      this.$emit('getVal', value) // （ag-grid中使用必须有）
    },
    // change事件
    changeEve(v) {
      v = this.datetime === 'end' ? moment(v).endOf('day')._d : v
      console.log('changeEve', v)
      this.$emit('getVal', v)
      this.$emit('change', v)
    },
    // 聚焦事件
    focusAction(e) {
      // console.log('所选日期--', e.value)
      this.$emit('focus', e) // （ag-grid中使用必须有）
    },
    // 失焦事件
    blurAction(e) {
      // console.log('所选日期--', e.value)
      this.$emit('blur', e) // （ag-grid中使用必须有）
    }
  }
}
</script>
